// extracted by mini-css-extract-plugin
export default {"container":"WJ-z","dimension":"XJ-z","dimensionLabels":"YJ-z"};